import {
    CAMPAIGN_MOSCOW_AREA_REGION,
    CAMPAIGN_MOSCOW_REGION,
    CAMPAIGN_SELECTED_ROOT_REGION,
} from 'utils/constants/campaign';

import { selectRegions } from 'store/autoReducers';
import { setCampaignExcludedRegions, setCampaignRegions } from 'store/models/createCampaign';
import { AppThunkAction } from 'store/utils';

export const setAllRegionsWithoutMoscow = (): AppThunkAction<void> => {
    return (dispatch, getState) => {
        const regions = selectRegions(getState())[0]?.areas;

        if (regions) {
            dispatch([
                setCampaignRegions(CAMPAIGN_SELECTED_ROOT_REGION),
                setCampaignExcludedRegions([CAMPAIGN_MOSCOW_REGION, CAMPAIGN_MOSCOW_AREA_REGION]),
            ]);
        } else {
            console.warn('setAllRegionsWithoutMoscow without regions');
        }
    };
};
